import { gql } from '@apollo/client'

export const REMOVE_STORES_FROM_ZONE = gql`
  mutation RemoveStoresFromZone($input: UpdateZoneInput!) {
    removeStoresFromZone(input: $input) {
      success
    }
  }
`
